if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        if (opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          opener.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        fetch(opener?.getAttribute('data-product-url') || this.dataset.productUrl)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            // ✅ Only select the section that contains <product-info>
            const productInfoEl = doc.querySelector('product-info');
            if (!productInfoEl) {
              this.setInnerHTML(this.modalContent, '<p>Unable to load product details.</p>');
              super.show(opener);
              return;
            }
            const productSection = productInfoEl.closest('section');
            if (!productSection) {
              this.setInnerHTML(this.modalContent, '<p>Unable to load product details.</p>');
              super.show(opener);
              return;
            }

            this.productElement = productSection;

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.outerHTML);

            // Reinitialize Shopify JS features
            if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            document.dispatchEvent(new Event('DOMContentLoaded'));

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            super.show(opener);
          })
          .catch(err => {
            console.error('Quick Add modal fetch failed:', err);
            this.setInnerHTML(this.modalContent, '<p>Unable to load product details.</p>');
            super.show(opener);
          })
          .finally(() => {
            if (opener) {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener.querySelector('.loading__spinner')?.classList.add('hidden');
            }
          });
      }

      setInnerHTML(el, html) {
        el.innerHTML = html;
        el.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr =>
            newScript.setAttribute(attr.name, attr.value)
          );
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          'variant-radios, variant-selects'
        );
        if (variantPicker) variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        ['pickup-availability', 'product-modal', 'modal-dialog'].forEach(selector => {
          this.productElement.querySelectorAll(selector).forEach(el => el.remove());
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset?.section;
        if (!sectionId) return;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );
        this.productElement
          .querySelectorAll('variant-selects, variant-radios, product-info')
          .forEach(el => {
            el.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach(li => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product) return;
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let sizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium'))
          sizes = sizes.replace('715px', '605px');
        else if (product.classList.contains('product--small'))
          sizes = sizes.replace('715px', '495px');

        mediaImages.forEach(img => img.setAttribute('sizes', sizes));
      }
    }
  );
}
